import { Box, Container, useTheme } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import DashboardSideDrawer from "../component/dashboard/Dashboard";
import Header from "../component/dashboard/Header";

const MainLayout = () => {
  const theme: any = useTheme();

  const [renderKey, setRenderKey] = React.useState("");

  return (
    <>
      <Header />
      <DashboardSideDrawer renderKey={renderKey} setRenderKey={setRenderKey} />
      <Box
        component="main"
        sx={{
          position: "relative",
          zIndex: 5,
          flex: 1,
          display: "flex",
          flexDirection: "column",
          pt: `${theme.header.height || "80px"}`,
          transition: theme.transitions.create(["padding-left"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          [theme.breakpoints.up("lg")]: {
            pl: `${theme.sidebar.width || "290px"}`,
          },
          width: "100%",
          minHeight: "100vh",
          overflowX: "hidden",
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            p: { xs: 1.5, sm: 2.5, md: 3 },
            width: "100%",
            maxWidth: { xs: "100%", lg: "1440px", xl: "1600px" },
            mx: "auto",
            boxSizing: "border-box",
            overflowX: "hidden",
          }}
        >
          <Outlet />
        </Container>
      </Box>
    </>
  );
};

export default MainLayout;
